export enum BonusCoinMappingsQueryKey {
  Primary = '/bonus-coin-mapping',
}
